import { useRouter } from 'next/router';

export function useIsRightToLeft() {
  const router = useRouter();
  return router.locale === 'ar';
}
